import { isProd } from 'src/utils/is-prod';
import { CONSENT_LOG_PREFIX } from './constants';

/** Closed union so the Datadog log explorer has a stable set of names. */
type ConsentLifecycleEvent =
  | 'init.resolved'
  | 'consent.set'
  | 'consent.changed'
  | 'consent.revocation_reload'
  | 'consent.error'
  | 'ui.crashed'
  | 'script.debug';

/**
 * Single sink for consent lifecycle telemetry. `DD_LOGS` loads lazily, so the
 * earliest events reach the console only — that gap is expected, not a bug.
 */
export function logConsentEvent(
  event: ConsentLifecycleEvent,
  payload: Record<string, unknown> = {},
): void {
  if (typeof window === 'undefined') {
    return;
  }

  if (!isProd) {
    console.info(`${CONSENT_LOG_PREFIX} ${event}`, payload);
  }

  const level =
    event === 'consent.error' || event === 'ui.crashed' ? 'error' : 'info';

  window.DD_LOGS?.logger?.log?.(
    `${CONSENT_LOG_PREFIX} ${event}`,
    payload,
    level,
  );
}
